//@flow
import * as React from 'react';
import { translate, type TFunction } from 'react-i18next';

type Props = {
    onChange: (value: string) => void,
    t: TFunction
};

class FilterCellComponent extends React.PureComponent<Props> {
    _onChange = event => {
        this.props.onChange(event.target.value);
    };
    render() {
        // can't use neo input as styles override are not possible
        return (
            <input
                onChange={this._onChange}
                placeholder={`${this.props.t('search')}...`}
            />
        );
    }
}

const FilterCell = translate('translations')(FilterCellComponent);

export { FilterCell };
